(function () {
  'use strict';

  
  angular
    .module('indiCrewExpiryLog', [
      'ui.router'
    ]);
}());
